import React from 'react';
import './Services.css';

export default function Services() {
  const projects = [
    { src: '/Project1.jpg', alt: 'Project snapshot 1' },
    { src: '/Project2.jpg', alt: 'Project snapshot 2' },
    { src: '/Project%203.jpg', alt: 'Project snapshot 3' },
  ];

  return (
    <section className="section services anchor" id="services">
      <div className="container">
        <header className="services__header">
          <h2 className="services__title">Services</h2>
          <p className="services__subtitle">
            Choose project delivery, IT support, or a blended approach built for teams that need
            dependable outcomes.
          </p>
        </header>

        <div className="services__grid">
          <article className="services__card">
            <h3>Project Management</h3>
            <p>
              From kickoff to launch, I keep stakeholders aligned and delivery predictable so you
              ship with confidence.
            </p>
            <div className="services__split">
              <div>
                <h4>What I Offer</h4>
                <ul>
                  <li>End-to-end project planning and execution</li>
                  <li>Agile & Scrum leadership</li>
                  <li>Risk and change management</li>
                  <li>Stakeholder coordination and reporting</li>
                </ul>
              </div>
              <div>
                <h4>Tools I Use</h4>
                <div className="services__tags" aria-label="Tools">
                  <span className="services__tag">Jira</span>
                  <span className="services__tag">Microsoft Project</span>
                  <span className="services__tag">Monday.com</span>
                  <span className="services__tag">ClickUp</span>
                  <span className="services__tag">Asana</span>
                </div>
              </div>
            </div>
          </article>

          <article className="services__card">
            <h3>IT Support & Infrastructure</h3>
            <p>
              I troubleshoot, stabilize, and improve support processes so your systems stay reliable
              and incidents get resolved fast.
            </p>
            <div className="services__split">
              <div>
                <h4>What I Offer</h4>
                <ul>
                  <li>Network and systems troubleshooting</li>
                  <li>Application and production support</li>
                  <li>ITIL-based service management</li>
                  <li>Security monitoring and incident response</li>
                </ul>
              </div>
              <div>
                <h4>Best For</h4>
                <ul>
                  <li>Teams needing dependable support coverage</li>
                  <li>Reducing downtime and recurring incidents</li>
                  <li>Improving response and escalation processes</li>
                  <li>Stabilizing environments during change</li>
                </ul>
              </div>
            </div>
          </article>
        </div>

        <div className="services__gallery" aria-label="Project images">
          {projects.map((p) => (
            <figure className="services__galleryItem" key={p.src}>
              <img className="services__galleryImg" src={p.src} alt={p.alt} loading="lazy" />
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
